export default "__VITE_ASSET__5t1qyHn4__"